import { ChangeDetectorRef, Component, ElementRef, EventEmitter, HostListener, Input, OnInit, Output, Renderer2, ViewChild } from '@angular/core';
import { MenuItem, MessageService } from 'primeng/api';
import { MessageChat, NoteRequest } from 'src/app/interfaces/userchatcrm';
import { Chats, Status } from 'src/app/interfaces/chatData';
import { ChatsService } from 'src/app/service/chats.service';
import { LoginService } from 'src/app/service/login.service';
import { MessageData } from 'src/app/service/messageData';
import { MessagesService } from 'src/app/service/messages.service';
import { UsersService } from 'src/app/service/users.service';
import { GoogleMap } from '@angular/google-maps';
import * as L from 'leaflet';
import * as Mark from 'mark.js';
import { TranslateService } from '@ngx-translate/core';
import { ActivatedRoute } from '@angular/router';


@Component({
  selector: 'app-message-screen',
  templateUrl: './message-screen.component.html',
  styleUrls: ['./message-screen.component.scss'],
  providers: [MessageService, GoogleMap],
})
export class MessageScreenComponent implements OnInit {
  
  @Input() dataMessages: MessageData[] = [];
  @Input() Id: string = '';
  @Output() rightSideBar: EventEmitter<any> = new EventEmitter();
  @ViewChild('messagesContainer') messagesContainer!: ElementRef;
  
  @ViewChild('barraContainer') barraContainer!: ElementRef;
  @ViewChild('responderContainer') responderContainer!: ElementRef;

  highlightMessage = false;
  highlightMessagePart = false;
  highlightedMessage: any = null;
  highlightedPartialMessage: any = null;
  showInputs: boolean = false
  selectedImageFile!: any;
  nuevosChats!: Chats[]
  notes: NoteRequest[] = []
  selectedChat: Chats | null = null;
  activeTab: number = 0
  messages: MessageData[] = []
  items: MenuItem[] = [];
  usuarios: any[] = [];
  items4: MenuItem[] = [];
  items3: MenuItem[] = [];
  selectedImageUrl: string | null = null;
  isImageSelected: boolean = false;
  contactName: any;
  contactNameNew: any;
  isEditingName: boolean = false;
  isFileSelected: boolean = false;
  isLocationSelected: boolean = false;
  selectedDocumentName: any;
  isCustomer: boolean = false;
  isImage: boolean = false;
  idUsuario: any
  idUser!: number;
  newMsg: string = "";
  newNote: string = "";
  mediaModal: boolean = false;
  contactModal: boolean = false;
  signatureModal: boolean = false;
  quickreplyModal: boolean = false;
  showEmojiPicker = false;
  ht!: string
  perv!: string 
  datos: string = '';
  selectedDocumentFile: File | null = null;
  idSuscription!: number | null;
  rolUsuario: number;
  idStatus!: number | null;
  chats: Chats[] = [];
  estatus: Status[] = [];
  estatusMostrarSelect!: number | undefined | null
  showUser!: any;
  chatIdSelected: any
  pageNumber = 0
  pageSize: number = 20;
  loadingMessages: boolean = false;
  pageSet!: number
  searchTerm!: string;
  private loadingPreviousPage = false;
  isManualScroll = true;
  peticion: boolean = false
  sendingMessage: boolean = false;
  mostrarTextoMarcado: boolean = false

  idrol!: number;
  messageChat: MessageChat = {
    chatId: "",
    idUser: 0,
    user: "",
    message: "",
    idStatus: 0
  }
  note: NoteRequest = {
    idUser: 0,
    isCustomer: false,
    content: "",
    chatId: "",
    date: ""
  }
  
  statusItems: any[] = [
    { label: 'Pendientes', idStatus: 1, icon: "pi pi-clock pb-0" },
    { label: 'Resueltos', idStatus: 2, icon: "pi pi-check-circle pb-0" },
    { label: 'Bloqueado', idStatus: 3, icon: "pi pi-times-circle pb-0" },
    { label: 'Asignado', idStatus: 4, icon: "pi pi-check-circle pb-0" },
    { label: 'No leídos', idStatus: 5, icon: "pi pi-chevron-circle-down pb-0" }
  ];
  currentPage: number = 0;
  countMsg!: number;

  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    if (window.innerWidth < 780) {
      this.perv = "0.485"
    }
    if (window.innerWidth > 960 && window.innerWidth < 1500) {
      this.perv = "0.645"
    }
    if (window.innerWidth > 1500 && window.innerWidth < 1600) {
      this.perv = "0.685"
    }
    if (window.innerWidth > 1600 && window.innerWidth < 2000) {
      this.perv = "0.750"
    }
    if (window.innerWidth > 2000) {
      this.perv = "0.815"
    }

    if (this.barraContainer != undefined && this.responderContainer != undefined) {
      this.ht = window.innerHeight.toString()
      const barra = this.barraContainer.nativeElement.offsetHeight;
      const responder = this.responderContainer.nativeElement.offsetHeight;
      const resultadoPantalla = window.innerHeight - (responder + barra);
      this.ht = resultadoPantalla.toString();
    }
    // this.ht = window.innerHeight.toString()
    // const barra = this.barraContainer.nativeElement.offsetHeight;
    // const responder = this.responderContainer.nativeElement.offsetHeight;
    // const message = this.messagesContainer.nativeElement.offsetHeight;
    // console.log("HT VALOR:",this.ht);
    // console.log("BARRA VALOR: ",barra + ", MENSAJES VALOR: ",message
    // + ", RESPONDER VALOR: ",responder+ " HEIGTH TOTAL -> ",(barra+message+responder));
  }

  constructor(private messageService: MessagesService,
    private loginservice: LoginService,
    private chatservice: ChatsService,
    private userservice: UsersService,
    private messagesService: MessageService,
    private renderer: Renderer2, private cdr: ChangeDetectorRef,
    private route: ActivatedRoute, private translate: TranslateService) {
    this.rolUsuario = this.loginservice.chatCrmUser.idRol;
    this.messageService.obtenerInfoContacto().subscribe((data) => {
      if (data == null) {
        this.datos = '';

      }
      this.datos = data;
      if (this.datos) {
        this.dataMessages = []
        this.ocultarPanelesExtra();
        this.onResize('');
        this.newMsg = "";
        this.showUser = null;
        this.estatusMostrarSelect = null;
      }
      this.contactNameNew = this.datos
    });

    this.messageService.dispositivo$().subscribe(data => {
      this.idSuscription = data == null ? null : data.id;
      if (this.idSuscription != null) {
        this.obtenerCatalogoUsuariosDispositivo(this.idSuscription);
      }
      this.dataMessages = []
      this.ocultarPanelesExtra();
      this.newMsg = "";
    });

    this.messageService.selectedChat$.subscribe((chat) => {
      if (chat == undefined || chat == null) {
        this.selectedChat = null;
        return;
      }
      if(this.searchTerm !== ''){
        this.mostrarTextoMarcado = true
        console.log('hay termino', this.mostrarTextoMarcado)
        setTimeout(() => {
          this.mostrarTextoMarcado =false
          console.log('entro', this.mostrarTextoMarcado)
        }, 3400);
      }
      this.selectedChat = chat;
      this.chatIdSelected = chat.chatId
      if (chat.name) {
        this.contactName = chat.name
      } else {
        this.contactName = chat.chatId
      }

      if (!chat) {
        this.estatusMostrarSelect = null
      }
      if (chat.idStatus !== 0 && chat.idStatus !== null) {
        this.estatusMostrarSelect = chat.idStatus
      } 
      else {
        this.estatusMostrarSelect = null
      }
      // if(chat.idStatus === null || chat.idStatus === 0 && this.showUser !== null){
      //   this.estatusMostrarSelect = 4
      //   messageService.establecerEstatus(this.estatusMostrarSelect)
      // }
      this.showUser = this.selectedChat.idUser ? this.selectedChat.idUser : null;
      this.ocultarPanelesExtra();
      this.onResize('');
      this.newMsg = "";
    });

    this.messageService.messages$.subscribe((msg) => {
      this.dataMessages = msg;
      this.messageService.getShowUser().subscribe(user => {
        if (!this.datos) {
          this.showUser = user;
        }
        if(this.showUser === this.loginservice.chatCrmUser.id){
          this.showUser = 0
        }
        // if(user === null){
        //   this.estatusMostrarSelect = null
        //   messageService.establecerEstatus(null)
        //   this.idStatus = 0
        // }
      })
      this.onResize('')
      setTimeout(() => {
        this.scrollToBottom();
        
        if (this.searchTerm !== '') {
          this.highlightedMessage = this.dataMessages.find((message) => {
            return message.message && message.message.toLowerCase().includes(this.searchTerm.toLowerCase());
          });
          
          // Luego, después de un segundo (1000 ms), desactiva el resaltado.
          setTimeout(() => {
            this.clearHighlight();
          }, 2000);
        }
      }, 5);
      
    });

    this.messageService.notes$.subscribe((notes) => {
      this.notes = notes;
    });

    this.messageService.idStatus$.subscribe((idStatus) => {
      this.idStatus = idStatus;
      this.estatusMostrarSelect = idStatus
      console.log('id', idStatus)
    });

    this.messageService.getPage().subscribe(value => {
      this.pageSet = value;
      if (this.pageSet != 0) {
        this.currentPage = this.pageSet !== 0 ? this.pageSet : this.pageNumber;
      }
    });

    this.messageService.searchTerm$.subscribe(value => {
      this.searchTerm = value
    });

    this.messageService.messageCount$.subscribe(countMsg => {
      this.countMsg = countMsg;
      setTimeout(() => {
        this.scrollToMessage(countMsg)
      }, 2000);

      this.clearHighlight();

    });
    this.checkEmptyMessage()
    // Establecer idiomas disponibles y el idioma por defecto
    translate.addLangs(['en', 'es']);
    translate.setDefaultLang('es');
  }

  sendRB() {
    this.rightSideBar.emit(true);
  }

  ngOnInit(): void {
    this.contactName = '';
    this.contactNameNew = '';
    this.datos = '';
    this.selectedChat = null;
    this.dataMessages = [];
    this.idrol = this.loginservice.chatCrmUser.idRol;
    this.chatservice.obtenerStatus(this.loginservice.chatCrmUser.idCustomer).then(data => this.estatus = data.data);
    // this.chatservice.obtenerStatus().then(data => {
    //   const arrayModificado = data.data.map((objeto: { name: string, icon: string }) => {
    //     return { label: objeto.name, icon: objeto.icon };
    //   });
    //   this.items = arrayModificado;
    // });

    const element = document.getElementById('scrollId');
    element?.scrollIntoView({ behavior: 'smooth', block: 'end', inline: 'nearest' });

    // setTimeout(() => {
    //   this.messagesContainer.nativeElement.addEventListener('scroll', () => {
    //     this.isManualScroll = true;
    //   });
    // }, 1000);

    this.onResize('');

    // Obtener el parámetro 'lang' de la URL
    this.route.queryParams.subscribe(params => {
      const lang = params['lang'];
      if (lang) {
        this.translate.use(lang);
      } else {
        this.translate.use('es'); // Idioma por defecto
      }
    });
  }

  markInstance: Mark | null = null;

  isTextHighlighted: boolean = false;

  
  highlightSearchTerm(text: string | null, searchTerm: string): string {
    if (!searchTerm || !text) {
      if(text){
        return text;
      }else{
        return 'null'
      }
      
    }
    // Crear un elemento HTML temporal para usar "mark.js"
    const tempElement = document.createElement('div');
    tempElement.innerHTML = text;
    if(this.searchTerm !== ''){
      // Resaltar el término de búsqueda utilizando "mark.js"
      const markInstance = new Mark(tempElement);
      markInstance.mark(searchTerm);
    }
    // Devolver el contenido resaltado como HTML
    return tempElement.innerHTML;
  }  

  private obtenerCatalogoUsuariosDispositivo(idDispositivo: number) {
    this.userservice.catalogoUsuarios(idDispositivo, this.loginservice.chatCrmUser.id).then(data => {
      const arrayModificado = data.data.map((objeto: { name: string, icon: string, id: number }) => {
        return {
          label: objeto.name,
          icon: "pi pi-user",
          idUser: objeto.id
        };
      });
      this.usuarios = arrayModificado;
    });
  }
  

  async scrollToMessage(messageCount: number): Promise<void> {
    const messageToHighlight = this.dataMessages.find(message => message.messageCount === messageCount);
    if (messageToHighlight) {
      const indexToScroll = this.dataMessages.findIndex(message => message.messageCount === messageCount);
      if (indexToScroll !== -1) {
        // Calcula el índice en función del número total de mensajes
        const totalMessages = this.dataMessages.length;
        const indexToScrollFromTop = totalMessages - indexToScroll - 1;
        // Desplázate al mensaje en el contenedor
        const container = this.messagesContainer.nativeElement;
        const messages = container.querySelectorAll('.row.pd-15');
        const messageToScroll = messages[indexToScrollFromTop];
        if (messageToScroll) {
          messageToScroll.scrollIntoView();
        }
      }
    }
    if (this.pageSet > 0 && this.isManualScroll) {
      for (let i = this.pageSet - 1; i < this.pageSet; i--) {
        const chatIdSelected = this.selectedChat?.chatId;
        const getMessages = await this.messageService.getMessages(chatIdSelected, this.idSuscription, i, 20);
        this.dataMessages.unshift(...getMessages.data)
        if (i < 0) {
          this.isManualScroll = false;
        }
      }

    }

  }

  sinContenido: boolean = true
  checkEmptyMessage() {
    const sendButton = document.querySelector('.custImg');
    if (sendButton) {
      sendButton.classList.toggle('disabled', this.newMsg.trim() === '');
    }
  }

  

  verDocumento(url: string) {
    window.open(url, '_blank');
  }

  sendMsg(): void {
    // const emojiText = "\u{1F604}";
    if (this.datos !== "" && this.datos !== null) {
      // Convierte el emoji seleccionado en su representación de texto (por ejemplo, "\u{1F604}")
      //    this.newMsg += emojiText;
      this.messageChat = {
        chatId: this.datos,
        idUser: this.selectedChat?.idUser ? this.selectedChat?.idUser : null,
        user: this.loginservice.chatCrmUser.user,
        message: this.newMsg,
        idStatus: this.selectedChat?.idStatus ? this.selectedChat?.idStatus : null
      };
    } else {
      this.messageChat = {
        chatId: this.selectedChat?.chatId,
        idUser: this.selectedChat?.idUser ? this.selectedChat?.idUser : null,
        user: this.loginservice.chatCrmUser.user,
        message: this.newMsg,
        idStatus: this.selectedChat?.idStatus ? this.selectedChat?.idStatus : null
      };
    }
    if(this.newMsg === ''){
      return;
     }
    if (this.idSuscription == null) {
      return;

    }
    this.userservice.mandarMensaje(this.idSuscription, this.loginservice.chatCrmUser.idCustomer, this.messageChat)
      .then(async result => {
        this.newMsg = '';
        if (this.validarEnvioMensaje(result)) {

          // this.messagesService.add({ severity: 'success', summary: 'Éxito', detail: 'Mensaje enviado!!' });
          
        }
        if (this.idSuscription == null) {
          return;
        }
        this.messageService.getMessages(this.messageChat.chatId, this.idSuscription, 0, 20)
          .then(value => {
            const response: MessageData[] = value.data;
            this.dataMessages = response;
            this.messageService.setMessages(this.dataMessages);
          })

        this.ocultarPanelesExtra();
        if (this.rolUsuario === 1 || this.rolUsuario === 2) {
          const response = await this.messageService.getConversations(this.idSuscription, this.idStatus);
          this.nuevosChats = response.data.result
        } else {
          const idUser = this.loginservice.chatCrmUser.id;
          const response = await this.messageService.getConversations(this.idSuscription, this.idStatus, idUser);
          this.nuevosChats = response.data.result
        }
        this.messageService.setChats(this.nuevosChats)
        this.scrollToBottom()
      })
      .catch(error => {
        console.error("Error al enviar mensaje", error);
        this.messagesService.add({ severity: 'error', summary: 'Error', detail: this.translate.instant('MESSAGE_SCRREN_ERROR_MESSAGE2')});
      });

  }


  sendNote() {
    const chatId = this.datos || (this.selectedChat ? this.selectedChat.chatId : '');

    if (chatId) {
      const isCustomer = this.loginservice.chatCrmUser.idRol === 1;
      this.note = {
        idUser: this.loginservice.chatCrmUser.id,
        isCustomer: isCustomer,
        content: this.newNote,
        chatId: chatId
      };
     if(this.newNote === ''){
      this.messagesService.add({
        severity: 'error', summary: 'Error',
        detail: this.translate.instant('MESSAGE_SCRREN_ERROR_MESSAGE3'),
      });
      return;
     }
      this.userservice.crearNota(this.note)
        .then((result) => {
          // Una vez creada la nota, obtén las notas actualizadas para el chat.
          this.messageService.getNotesForChat(chatId).then((notes) => {
            // Actualiza la lista de notas en el servicio de mensajes.
            this.messageService.updateNotes(notes.data);
          });

          // this.messagesService.add({ severity: 'success', summary: 'Exito', detail: 'Nota agregada!!' });
          this.newNote = '';
          
        })
        .catch(error => {
          console.error(error);
          this.messagesService.add({
            severity: 'error', summary: 'Error',
            detail: this.translate.instant('MESSAGE_SCRREN_ERROR_MESSAGE5'),
          });
        });
      ;
    }
  }

  private sendImage(): void {
    const fileInput = document.getElementById('fileInput') as HTMLInputElement;
    if (fileInput) {
      const file: File | null = fileInput.files?.[0] || null;
      if (file) {
        let chatIdSelected: string | undefined = ''
        if (this.datos !== "" && this.datos !== null) {
          chatIdSelected = this.datos;
        } else {
          chatIdSelected = this.selectedChat?.chatId
        }
        const request = {
          contentText: this.newMsg ? this.newMsg : '',
          chatId: chatIdSelected,
          user: this.loginservice.chatCrmUser.user,
          idUser: this.selectedChat?.idUser ? this.selectedChat.idUser : null,
          idStatus: this.selectedChat?.idStatus ? this.selectedChat.idStatus : null,
        };
        const formData: FormData = new FormData();
        const blob = new Blob([JSON.stringify(request)], { type: "application/json" });
        formData.append('image', file);
        formData.append('request', blob);
        if (this.idSuscription == null) {
          return;
        }
        this.messageService.sendImage(this.idSuscription, this.loginservice.chatCrmUser.idCustomer, formData)
          .then(async (result) => {
            if (this.validarEnvioMensaje(result)) {
              // this.messagesService.add({ severity: 'success', summary: 'Éxito', detail: 'Imagen enviada con exito!!' });
            }

            if (this.idSuscription == null) {
              return;
            }
            this.messageService.getMessages(request.chatId, this.idSuscription, 0, 20).then(value => {

              const response: MessageData[] = value.data
              this.dataMessages = response
              this.messageService.setMessages(this.dataMessages)
            })
            this.newMsg = '';
            if (this.rolUsuario === 1 || this.rolUsuario === 2) {
              const response = await this.messageService.getConversations(this.idSuscription, this.idStatus);
              this.nuevosChats = response.data.result
            } else {
              const idUser = this.loginservice.chatCrmUser.id;
              const response = await this.messageService.getConversations(this.idSuscription, this.idStatus, idUser);
              this.nuevosChats = response.data.result

            }
            this.isImage = true;
            this.messageService.setChats(this.nuevosChats)
            this.scrollToBottom()
            this.clearImageSelection()
          })
          .catch((error) => {
            if (error.error && error.error.value == -2) {
              this.messagesService.add({
                severity: 'error', summary: this.translate.instant('MESSAGE_SCRREN_SUMMARY_MESSAGE7'),
                detail: error.error.message,
              });
              return;
            }
            console.error("Error al enviar Imagen", error);
            this.messagesService.add({
              severity: 'error',
              summary: 'Error',
              detail: this.translate.instant('MESSAGE_SCRREN_ERROR_MESSAGE8'),
            });
          });
      } else {
        this.messagesService.add({
          severity: 'error',
          summary: 'Error',
          detail: this.translate.instant('MESSAGE_SCRREN_ERROR_MESSAGE9'),
        });
      }
    } else {
      console.error("File input element not found.");
    }
  }

  sendDocument(): void {
    const documentInput = document.getElementById('documentInput') as HTMLInputElement;
    if (documentInput) {
      const documentFile: File | null = documentInput.files?.[0] || null;

      if (documentFile) {
        // Create a FormData object to send the document

        let chatIdSelected: string | undefined = ''
        if (this.datos !== "" && this.datos !== null) {
          chatIdSelected = this.datos;
        } else {
          chatIdSelected = this.selectedChat?.chatId
        }
        const request = {
          contentText: this.newMsg ? this.newMsg : '',
          chatId: chatIdSelected,
          user: this.loginservice.chatCrmUser.user,
          idUser: this.selectedChat?.idUser ? this.selectedChat.idUser : null,
          idStatus: this.selectedChat?.idStatus ? this.selectedChat.idStatus : null,
        };
        const formData: FormData = new FormData();
        const blob = new Blob([JSON.stringify(request)], { type: "application/json" });
        formData.append('image', documentFile);
        formData.append('request', blob);

        if (this.idSuscription == null) {
          return;
        }
        this.messageService.sendFile(this.idSuscription, this.loginservice.chatCrmUser.idCustomer, formData)
          .then(async (result) => {
            if (this.validarEnvioMensaje(result)) {
              // this.messagesService.add({ severity: 'success', summary: 'Éxito', detail: 'Documento enviado con éxito!' });
            }

            if (this.idSuscription == null) {
              return;
            }
            this.selectedDocumentFile = null;
            this.messageService.getMessages(request.chatId, this.idSuscription, 0, 20).then(value => {
              const response: MessageData[] = value.data
              this.dataMessages = response
              this.messageService.setMessages(this.dataMessages)
            })
            this.newMsg = '';
            if (this.rolUsuario === 1 || this.rolUsuario === 2) {
              const response = await this.messageService.getConversations(this.idSuscription, this.idStatus);
              this.nuevosChats = response.data.result
            } else {
              const idUser = this.loginservice.chatCrmUser.id;
              const response = await this.messageService.getConversations(this.idSuscription, this.idStatus, idUser);
              this.nuevosChats = response.data.result

            }
            this.messageService.setChats(this.nuevosChats)
            this.scrollToBottom()
            this.clearFileSelection()
            ;
          })
          .catch((error) => {
            if (error.error && error.error.value == -2) {
              this.messagesService.add({
                severity: 'error', summary: this.translate.instant('MESSAGE_SCRREN_SUMMARY_MESSAGE11'),
                detail: error.error.message,
              });
              return;
            }
            console.error("Error al enviar documento", error);
            this.messagesService.add({
              severity: 'error',
              summary: 'Error',
              detail: this.translate.instant('MESSAGE_SCRREN_ERROR_MESSAGE12') ,
            });
            
          });
      } else {
        this.messagesService.add({
          severity: 'error',
          summary: 'Error',
          detail: this.translate.instant('MESSAGE_SCRREN_ERROR_MESSAGE13'),
        });
      }
    } else {
      console.error("Document input element not found.");
    }
  }


  async onScroll() {
    const container = this.messagesContainer.nativeElement;

    if (container.scrollTop === 0) {
      this.currentPage++;

      await this.loadMoreMessages();

      if (this.dataMessages.length > 100) {
        const overflow = this.dataMessages.length - 100; // Calcula la cantidad de mensajes excedentes
        this.dataMessages.splice(0, overflow); // Elimina los mensajes excedentes
      }

      this.cdr.detectChanges();

    }
  }

  async loadMoreMessages() {
    if (!this.peticion) {
      this.loadingMessages = true;
      if (this.idSuscription == null) {
        return;
      }
      const response = await this.messageService.getMessages(
        this.selectedChat?.chatId,
        this.idSuscription,
        this.currentPage,
        this.pageSize
      );

      if (Array.isArray(response.data) && response.data.length > 0) {
        this.dataMessages = this.dataMessages.concat(response.data);
      } else {
      }

      this.loadingMessages = false;
    }

  }
  


  sendMessageOrImage(): void {
    // if (this.isLocationSelected === true && !this.isFileSelected && !this.selectedImageFile) {
    //   console.log('esta llamando a send location')
    //   this.sendLocationToService(this.latitudModal, this.longitudModal,
    //      this.direccionModal, this.googleMapsUrl)
    // }
    this.sendingMessage = true
    if (this.selectedImageFile && !this.isLocationSelected) {
      this.sendImage();
    }
    if (this.isFileSelected === true && !this.selectedImageFile && !this.isLocationSelected) {
      this.sendDocument();
    }
    if (!this.isFileSelected && !this.selectedImageFile && !this.isLocationSelected) {
      this.sendMsg();
    }
    this.sendingMessage = false
    this.sinContenido = true
  }

  // Method to handle document selection
  onDocumentSelected(event: any): void {
    const documentFile: File = event.target.files[0];
    if (documentFile) {
      this.isFileSelected = true
      this.sinContenido = false
      this.selectedDocumentFile = documentFile;
      this.selectedDocumentName = documentFile.name;
    }
  }


  onFileSelected(event: any): void {
    const file: File = event.target.files[0];
    if (file) {
      const isImage = file.type.startsWith('image/');
      if (isImage) {
        this.selectedImageFile = file;
        this.selectedImageUrl = URL.createObjectURL(file);
        this.isImageSelected = true;
        this.sinContenido = false
      } else {
        this.selectedImageFile = null;
        this.selectedImageUrl = null;
        this.isImageSelected = false;
        this.sinContenido = true
      }
    }
  }
  

  clearImageSelection(): void {
    // Restablecer el valor del input del archivo a null
    const fileInput = document.getElementById('fileInput') as HTMLInputElement;
    if (fileInput) {
      fileInput.value = '';
    }
  
    this.selectedImageFile = null;
    this.selectedImageUrl = null;
    this.isImageSelected = false;
    this.sinContenido = true;
  }
  
  

  clearFileSelection(): void {
    const fileInput = document.getElementById('documentInput') as HTMLInputElement;
    if (fileInput) {
      fileInput.value = '';
    }
    this.selectedDocumentFile = null;
    this.selectedDocumentName = '';
    this.isFileSelected = false;
    this.sinContenido = true
  }


  onStatusChange(event: any): void {
    if (this.idSuscription == null) {
      this.estatusMostrarSelect = null;
      this.messagesService.add({ severity: 'error', summary: 'Error', detail: this.translate.instant('MESSAGE_SCRREN_ERROR_MESSAGE14') });
      return;
    }

    const idSuscription = this.idSuscription;
    const chatId = this.selectedChat? this.selectedChat.chatId : this.datos;
    const idStatus = event.target.value;
    if(idStatus == 4 && (this.showUser == null || this.showUser == undefined)){
      this.messageService.updateIdStatus(this.idStatus)
      console.log('estatus', this.estatusMostrarSelect)
      event.target.value = this.idStatus
      this.messagesService.add({ severity: 'error', summary: 'Error', detail: 'El chat no tiene un usuario asignado' });
      return
    }
      this.chatservice.updateStatus(idSuscription, chatId, idStatus).subscribe(
        (response) => {
          this.messagesService.add({ severity: 'success', summary: this.translate.instant('MESSAGE_SCRREN_SUCCESS_SUMMARY')  , detail: this.translate.instant('MESSAGE_SCRREN_SUCCESS_MESSAGE15') });
          this.messageService.updateIdStatus(idStatus)
          this.messageService.establecerEstatus(idStatus)
          this.peticion = true
        },
        (error) => {
              if(this.dataMessages.length === 0){
                this.messagesService.add({ severity: 'error', summary: 'Error', detail: this.translate.instant('MESSAGE_SCRREN_ERROR_MESSAGE16')});
                this.showUser = null
                this.estatusMostrarSelect = null
              }else{
                this.messagesService.add({ severity: 'error', summary: 'Error', detail: this.translate.instant('MESSAGE_SCRREN_ERROR_MESSAGE17')  });
              }    
              return;  
        }
      );
  }

  changeUser(event: any) {

    if (this.idSuscription == null) {
      return;
    }
    this.messageService.changeUser(this.idSuscription, this.selectedChat?.chatId ? this.selectedChat.chatId : this.datos, event.target.value).subscribe(
      async (response) => {
        this.messagesService.add({ severity: 'success', summary: this.translate.instant('MESSAGE_SCRREN_SUCCESS_SUMMARY')  , detail: this.translate.instant('MESSAGE_SCRREN_SUCCESS_MESSAGE18')  });
        this.showUser = event.target.value

        this.messageService.setShowUser(this.showUser)

        if (this.showUser !== null) {
          const idSuscription = this.idSuscription;
          const chatId = this.selectedChat ? this.selectedChat.chatId : this.datos;
          const idStatus = 4;
          if (this.estatusMostrarSelect !== idStatus) {
            this.chatservice.updateStatus(idSuscription, chatId, idStatus).subscribe(
              (response) => {
                //   this.messagesService.add({ severity: 'success', summary: 'Exito', detail: 'Estatus actualizado correctamente!' });
                this.messageService.updateIdStatus(idStatus)
                this.messageService.establecerEstatus(idStatus)
                this.peticion = true
              },
              (error) => {
                if (error.error) {
                  const errorResponse = error.error;
                  if (errorResponse.statusCode === 404) {
                    this.messagesService.add({ severity: 'error', summary: 'Error', detail: this.translate.instant('MESSAGE_SCRREN_ERROR_MESSAGE20')});
                    return;
                  }
                  console.error(errorResponse);
                }
              }
            );
          }
        }else{
          const idSuscription = this.idSuscription;
          const chatId = this.selectedChat ? this.selectedChat.chatId : this.datos;
          const idStatus = null;
          this.chatservice.updateStatus(idSuscription, chatId, idStatus).subscribe(
            (response) => {
              //   this.messagesService.add({ severity: 'success', summary: 'Exito', detail: 'Estatus actualizado correctamente!' });
              this.messageService.updateIdStatus(idStatus)
              this.messageService.establecerEstatus(idStatus)
              this.peticion = true
            },
            (error) => {
              if (error.error) {
                const errorResponse = error.error;
                if (errorResponse.statusCode === 404) {
                  this.messagesService.add({ severity: 'error', summary: 'Error', detail: this.translate.instant('MESSAGE_SCRREN_ERROR_MESSAGE22') });
                  return;
                }
                console.error(errorResponse);
              }
            }
          );
        }
      },
      (error) => {
        this.showUser = null;
          const errorResponse = error.error;
            if (this.dataMessages.length === 0) {
              this.messagesService.add({ severity: 'error', summary: 'Error', detail: this.translate.instant('MESSAGE_SCRREN_ERROR_MESSAGE23') });
              this.showUser = null
              this.estatusMostrarSelect = null
            }else{
              this.messagesService.add({ severity: 'error', summary: 'Error', detail: this.translate.instant('MESSAGE_SCRREN_ERROR_MESSAGE24') });
            }
            return;
      }
    );
  }

  toggleEdit() {
    this.isEditingName = !this.isEditingName;
  }


  editContactName() {
    if (this.isEditingName) {
      if (this.idSuscription == null) {
        return;
      }
      if (this.datos) {
        this.contactNameNew = this.contactNameNew;
        this.chatservice.editContactName(this.idSuscription, this.datos, this.contactNameNew).subscribe(
          (response) => {
            this.messagesService.add({ severity: 'success', summary: this.translate.instant('MESSAGE_SCRREN_SUCCESS_SUMMARY') , detail: this.translate.instant('MESSAGE_SCRREN_SUCCESS_MESSAGE25')   });
            this.isEditingName = false;
            this.chatservice.actualizarNombreContacto(this.datos, this.contactNameNew)
          },
          (error) => {
            this.messagesService.add({ severity: 'error', summary: 'Error', detail: this.translate.instant('MESSAGE_SCRREN_ERROR_MESSAGE26')  });
          }
        );
      } else if (this.selectedChat) {
        this.contactName = this.contactName;
        this.chatservice.editContactName(this.idSuscription, this.selectedChat.chatId, this.contactName).subscribe(
          (response) => {
            this.messagesService.add({ severity: 'success', summary: this.translate.instant('MESSAGE_SCRREN_SUCCESS_SUMMARY') , detail: this.translate.instant('MESSAGE_SCRREN_SUCCESS_MESSAGE27')});
            this.isEditingName = false;
            this.chatservice.actualizarNombreContacto(this.selectedChat?.chatId, this.contactName)
            this.messageService.setSelectedChat(this.selectedChat)
          },
          (error) => {
            this.messagesService.add({ severity: 'error', summary: 'Error', detail: this.translate.instant('MESSAGE_SCRREN_ERROR_MESSAGE28')  });
          }
        );
      }
    } else {
      this.isEditingName = true;
    }
  }



  boldMsg(): void {
    this.newMsg = this.newMsg + "*<bold>*"
  }
  italicMsg(): void {
    this.newMsg = this.newMsg + "_<italic>_"
  }
  quotesMsg(): void {
    this.newMsg = this.newMsg + "```<quote>```"
  }
  stripeMsg(): void {
    this.newMsg = this.newMsg + "~<strike>~"
  }
  openmediaModel(): void {
    this.mediaModal = true;
  }

  onImageUploaded() {
    this.mediaModal = false; // Cierra el diálogo cuando se carga la imagen
  }
  opencontactModel(): void {
    this.contactModal = true
  }
  opensignatureModel(): void {
    this.signatureModal = true
  }
  openquickreplyModel(): void {
    this.quickreplyModal = true
  }
  toggleEmojiPicker() {
    this.showEmojiPicker = !this.showEmojiPicker;
  }

  addEmoji(event: { emoji: { native: any; }; }) {
    if (this.newMsg !== '') {
      const text = `${this.newMsg} ${event.emoji.native}`;
      this.newMsg = text
    } else {
      const text = `${event.emoji.native}`;
      this.newMsg = text
    }
    this.sinContenido = false
  }

  trackByFn(index: number, item: MessageData): string {
    return item.id || index.toString();
  }

  clearHighlight(): void {
    this.highlightedMessage = null;
    this.highlightMessage = false;
    
  }



  // Declaraciones de variables
  showMap: boolean = false;
  @ViewChild('mapIframe') mapIframe!: ElementRef;
  map!: L.Map; // Objeto mapa Leaflet
  marker: L.Marker | null = null; // Marcador Leaflet
  latitude!: number | undefined;
  longitude!: number | undefined;
  direction!: string;
  url!: string;

  private sendLocationToService(latitude: any, longitude: any, direction: string, url: string) {
    const body = {
      latitude: latitude,
      longitude: longitude,
      direction: direction,
      url: url,
      chatId: this.datos !== null && this.datos !== "" ?
        this.datos : this.selectedChat?.chatId,
      idStatus: this.selectedChat?.idStatus ? this.selectedChat?.idStatus : null,
      user: this.loginservice.chatCrmUser.user,
      idUser: this.selectedChat?.idUser ? this.selectedChat.idUser : null,
    };

      this.messageService.sendLocation(this.idSuscription, this.loginservice.chatCrmUser.idCustomer, body)
        .then(async response => {
          if (this.validarEnvioMensaje(response)) {
            // this.messagesService.add({ severity: 'success', summary: 'Éxito', detail: 'Ubicacion enviada correctamente!' });
          }

          this.messageService.getMessages(this.selectedChat?.chatId, this.idSuscription, 0, 20).then(value => {
            const response: MessageData[] = value.data
            this.dataMessages = response
            this.messageService.setMessages(this.dataMessages)
          })
          this.newMsg = '';
          if (this.rolUsuario === 1 || this.rolUsuario === 2) {
            const response = await this.messageService.getConversations(this.idSuscription, this.idStatus);
            this.nuevosChats = response.data.result
          } else {
            const idUser = this.loginservice.chatCrmUser.id;
            const response = await this.messageService.getConversations(this.idSuscription, this.idStatus, idUser);
            this.nuevosChats = response.data.result
          }
          this.messageService.setChats(this.nuevosChats)
          this.scrollToBottom()
          this.isLocationSelected = false
        })
        .catch(error => {
          console.error(error);
          this.messagesService.add({ severity: 'error', summary: 'Error', detail: this.translate.instant('MESSAGE_SCRREN_ERROR_MESSAGE30')  });
        });
    
      this.latitudModal = '';
      this.longitudModal = '';
      this.googleMapsUrl = '';
      this.direccionModal = '';
  }

  closeMap() {
    this.showMap = false;
    this.isLocationSelected = false
    this.latitude = undefined; // Reiniciar la variable de latitud
    this.longitude = undefined; // Reiniciar la variable de longitud
    this.direction = ''; // Reiniciar la variable de dirección
    this.url = ''; // Reiniciar la variable de URL
    this.newMsg = ''
  }


  toggleMap() {
    const mapContainer = document.createElement('div');
    mapContainer.id = 'map';
    document.body.appendChild(mapContainer);

    this.showMap = !this.showMap;

    if (this.showMap) {
      // Si se muestra el mapa, obtén la ubicación actual
      this.getCurrentLocation();
    } else {
      this.newMsg = ''
    }
  }


  getCurrentLocation() {
    if ('geolocation' in navigator) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const { latitude: lat, longitude: lng } = position.coords;
          this.initializeMap(lat, lng);
        },
        (error) => {
          console.error('Error getting geolocation:', error);
          // Manejo de errores
        }
      );
    } else {
      console.error('Geolocation is not supported by this browser.');
      // Manejar la falta de soporte para geolocalización aquí
    }
  }

  initializeMap(lat: number, lng: number) {
    // Si ya hay un mapa, elimínalo
    if (this.map) {
      this.map.remove();
    }
  
    const iconRetinaUrl = 'assets/marker-icon-2x.png';
    const iconUrl = 'assets/marker-icon.png';
    const shadowUrl = 'assets/marker-shadow.png';
  
    setTimeout(() => {
      this.map = L.map('map', {
        center: [lat, lng],
        attributionControl: false,
        zoom: 15,
        layers: [L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
          attribution: '© OpenStreetMap contributors'
        })]
      });
  
      // Agregar el control de búsqueda al mapa
      // const searchControl = new (M.Control).Search({
      //   position: 'topright',
      //   layer: L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png'),
      //   propertyName: 'display_name',

      // });
      
  
      // this.map.addControl(searchControl);
  
      const iconDefault = L.icon({
        iconRetinaUrl,
        iconUrl,
        shadowUrl,
        iconSize: [25, 41],
        iconAnchor: [12, 41],
        popupAnchor: [1, -34],
        tooltipAnchor: [16, -28],
        shadowSize: [41, 41]
      });
      L.Marker.prototype.options.icon = iconDefault;
  
      // Suscripción al evento click en el mapa
      this.map.on('click', async (e: L.LeafletMouseEvent) => {
        const { lat, lng } = e.latlng;
        const address = await this.getAddressFromCoordinates(lat, lng);
        const mapURL = this.getMapURL(lat, lng);
  
        if (this.marker) {
          this.map.removeLayer(this.marker);
        }
  
        this.latitude = lat;
        this.longitude = lng;
        this.direction = address;
        this.url = mapURL;
  
        this.marker = L.marker([lat, lng]).addTo(this.map);
        this.newMsg = this.direction;
        this.isLocationSelected = true;
  
        const ubicacionSeleccionada = { lat, lng };
      });
    }, 500); // Un retraso de 500 milisegundos (ajusta este valor si es necesario)
  }

  async getAddressFromCoordinates(lat: number, lng: number): Promise<string> {
    const url = `https://nominatim.openstreetmap.org/reverse?format=jsonv2&lat=${lat}&lon=${lng}`;

    try {
      const response = await fetch(url);
      const data = await response.json();

      if (data && data.display_name) {
        return data.display_name;
      }

      return 'No se pudo obtener la dirección';
    } catch (error) {
      console.error('Error al obtener la dirección:', error);
      return 'Error al obtener la dirección';
    }
  }

  getMapURL(lat: number, lng: number, zoom: number = 15): string {
    return `https://www.openstreetmap.org/?mlat=${lat}&mlon=${lng}#map=${zoom}/${lat}/${lng}`;
  }

  redirectToURL(): void {
    const url = 'https://www.latlong.net/';
    window.open(url, '_blank');
    
  }

  googleMapsUrl: string = ''; // Variable para almacenar la URL de Google Maps
  latitudModal!: string;
  longitudModal!: string;
  direccionModal: string = ''
  // Método para generar la URL de Google Maps
  generateGoogleMapsUrl(latitud: string, longitud: string): void {
    this.googleMapsUrl = `https://www.google.com/maps?q=${latitud},${longitud}`;
  }
  
  // Método para guardar los datos
  saveLocationData(latitud: string, longitud: string, direccion: string): void {
    this.validarDatosLocacion(latitud, longitud, direccion)
    this.sendingMessage = true
    this.generateGoogleMapsUrl(latitud, longitud); // Generar la URL de Google Maps
    
    const locationData = {
      latitud,
      longitud,
      direccion,
      url: this.googleMapsUrl // Agregar la URL generada
    };
    this.isLocationSelected = true
    
    // this.newMsg = direccion
    this.showInputsLocation()
    // Puedes realizar acciones adicionales, como enviar los datos a un servicio o guardarlos localmente
    this.sendLocationToService(this.latitudModal, this.longitudModal,this.direccionModal, this.googleMapsUrl)
    this.sendingMessage = false
  }

  showInputsLocation(){
    this.showInputs = !this.showInputs
  }

  private validarDatosLocacion(latitud: string, longitud: string, direccion: string){
    if(this.validarCampo(latitud) && this.validarCampo(longitud) && this.validarCampo(direccion)){
      this.messagesService.add({ severity: 'error', summary: this.translate.instant('MESSAGE_SCRREN_SUMMARY_MESSAGE31_34') , detail: this.translate.instant('MESSAGE_SCRREN_ERROR_MESSAGE31')  });
      return;
    }
    if(this.validarCampo(latitud)){
      this.messagesService.add({ severity: 'error', summary: this.translate.instant('MESSAGE_SCRREN_SUMMARY_MESSAGE31_34') , detail: this.translate.instant('MESSAGE_SCRREN_ERROR_MESSAGE32')  });
      return;
    }
    if(this.validarCampo(longitud)){
      this.messagesService.add({ severity: 'error', summary: this.translate.instant('MESSAGE_SCRREN_SUMMARY_MESSAGE31_34') , detail: this.translate.instant('MESSAGE_SCRREN_ERROR_MESSAGE33') });
      return;
    }
    if(this.validarCampo(direccion)){
      this.messagesService.add({ severity: 'error', summary: this.translate.instant('MESSAGE_SCRREN_SUMMARY_MESSAGE31_34') , detail: this.translate.instant('MESSAGE_SCRREN_ERROR_MESSAGE34')  });
      return;
    }
  }

  private validarCampo(campo: string){
    if(campo == undefined || campo == null || campo === ''){
      return true;
    }
    return false;
  }

  sendLocationByLink(){
    const body = {
      // latitude: latitude,
      // longitude: longitude,
      // direction: direction,
      // url: url,
      chatId: this.datos !== null && this.datos !== "" ?
        this.datos : this.selectedChat?.chatId,
      idStatus: this.selectedChat?.idStatus ? this.selectedChat?.idStatus : null,
      user: this.loginservice.chatCrmUser.user,
      idUser: this.selectedChat?.idUser ? this.selectedChat.idUser : null,
    };
  }
  
  scrollToBottom() {
    try {
      if(this.messagesContainer === undefined){
        return;
      }
      const element = this.messagesContainer.nativeElement;
      element.scrollTop = element.scrollHeight;
      this.isManualScroll = false;
    } catch (err) {
      console.error(err);
    }
  }

  private ocultarPanelesExtra() {
    this.showEmojiPicker = false;
    this.showMap = false;
  }

  private validarEnvioMensaje(result: any): boolean {
    switch (result.value) {
      case 0: this.messagesService.add({
        severity: 'error', summary: this.translate.instant('MESSAGE_SCRREN_SUMMARY_MESSAGE35'),
        detail: this.translate.instant('MESSAGE_SCRREN_ERROR_MESSAGE35') ,
      });
        return false;
      case 1: this.messagesService.add({
        severity: 'info', summary: this.translate.instant('MESSAGE_SCRREN_SUMMARY_MESSAGE36'),
        detail: this.translate.instant('MESSAGE_SCRREN_INFO_MESSAGE36'),
      });
        return false;
      case -1: this.messagesService.add({
        severity: 'error', summary: this.translate.instant('MESSAGE_SCRREN_SUMMARY_MESSAGE37'),
        detail: this.translate.instant('MESSAGE_SCRREN_ERROR_MESSAGE37')  ,
      });
        return false;
    }

    return true;
  }

}

